export const MODULE = "sales-order-invoicing-create-partial";

export const AMOUNT_MODE_LINE_ITEMS = 1;
export const AMOUNT_MODE_SPECIFIC_AMOUNT = 2;
export const AMOUNT_MODE_PERCENTAGE = 3;
export const AMOUNT_MODE_REMAINING_AMOUNT = 4;

export const AMOUNT_MODES = [
  {
    value: AMOUNT_MODE_LINE_ITEMS,
    label: "Specific line items",
  },
  {
    value: AMOUNT_MODE_SPECIFIC_AMOUNT,
    label: "Specific dollar amount",
  },
  {
    value: AMOUNT_MODE_PERCENTAGE,
    label: "Percentage of total order value",
  },
  {
    value: AMOUNT_MODE_REMAINING_AMOUNT,
    label: "Remaining balance",
  },
];
